import { Component } from '@angular/core';

@Component({
  selector: 'rs-turn-on-mobile',
  templateUrl: 'turn-on-mobile.component.html',
  styleUrls: ['turn-on-mobile.component.scss']
})
export class TurnOnMobileComponent {}
